import { FormErrors } from "redux-form";

import { RegisterFormValues } from "./components/RegisterForm";

const PHONE_PATTERN = /^(\+84|0)(1[2689]|9)[0-9]{8}$/;

function validate(formValues: RegisterFormValues) {
  const errors: FormErrors<RegisterFormValues> = {};

  const genRequiredMsg = () => "Cần thiết";

  if (!formValues.name_last) {
    errors.name_last = genRequiredMsg();
  }

  if (!formValues.name_first) {
    errors.name_first = genRequiredMsg();
  }

  if (!formValues.email) {
    errors.email = genRequiredMsg();
  }

  if (!formValues.password) {
    errors.password = genRequiredMsg();
  } else if (formValues.password.length < 8) {
    errors.password = "Mật khẩu phải lớn hơn 7 chữ cái";
  }

  if (!formValues.phone) {
    errors.phone = genRequiredMsg();
  } else if (!PHONE_PATTERN.test(formValues.phone.replace(/\s/g, ""))) {
    errors.phone = "SĐT không hợp lệ";
  }

  return errors;
}

export default validate;



// WEBPACK FOOTER //
// ./src/routes/Account/register-form-validation.ts